var map = {
	"./API/ApiTokenManager": 60563,
	"./API/ApiTokenManager.vue": 60563,
	"./API/Index": 81441,
	"./API/Index.vue": 81441,
	"./Admin/Articles/Form": 60015,
	"./Admin/Articles/Form.vue": 60015,
	"./Admin/Articles/Index": 97272,
	"./Admin/Articles/Index.vue": 97272,
	"./Admin/BankAccounts/Form": 27794,
	"./Admin/BankAccounts/Form.vue": 27794,
	"./Admin/BankAccounts/Index": 42800,
	"./Admin/BankAccounts/Index.vue": 42800,
	"./Admin/Currencies/Form": 13895,
	"./Admin/Currencies/Form.vue": 13895,
	"./Admin/Currencies/Index": 64241,
	"./Admin/Currencies/Index.vue": 64241,
	"./Admin/Dashboard": 91845,
	"./Admin/Dashboard.vue": 91845,
	"./Admin/KycDocuments/Index": 65483,
	"./Admin/KycDocuments/Index.vue": 65483,
	"./Admin/Languages/Form": 48517,
	"./Admin/Languages/Form.vue": 48517,
	"./Admin/Languages/Index": 47228,
	"./Admin/Languages/Index.vue": 47228,
	"./Admin/Languages/Translations": 64719,
	"./Admin/Languages/Translations.vue": 64719,
	"./Admin/Launchpads/Form": 53365,
	"./Admin/Launchpads/Form.vue": 53365,
	"./Admin/Launchpads/Index": 36650,
	"./Admin/Launchpads/Index.vue": 36650,
	"./Admin/Liquidity/Index": 82597,
	"./Admin/Liquidity/Index.vue": 82597,
	"./Admin/Markets/Form": 8612,
	"./Admin/Markets/Form.vue": 8612,
	"./Admin/Markets/Index": 58164,
	"./Admin/Markets/Index.vue": 58164,
	"./Admin/Networks/Form": 47949,
	"./Admin/Networks/Form.vue": 47949,
	"./Admin/Networks/Index": 76531,
	"./Admin/Networks/Index.vue": 76531,
	"./Admin/Pages/Form": 7834,
	"./Admin/Pages/Form.vue": 7834,
	"./Admin/Pages/Index": 27671,
	"./Admin/Pages/Index.vue": 27671,
	"./Admin/Reports/AllWallets": 87352,
	"./Admin/Reports/AllWallets.vue": 87352,
	"./Admin/Reports/Deposits": 40179,
	"./Admin/Reports/Deposits.vue": 40179,
	"./Admin/Reports/FiatDeposits": 96772,
	"./Admin/Reports/FiatDeposits.vue": 96772,
	"./Admin/Reports/FiatWithdrawals": 61157,
	"./Admin/Reports/FiatWithdrawals.vue": 61157,
	"./Admin/Reports/LaunchpadTransactions": 70989,
	"./Admin/Reports/LaunchpadTransactions.vue": 70989,
	"./Admin/Reports/ReferralTransactions": 53127,
	"./Admin/Reports/ReferralTransactions.vue": 53127,
	"./Admin/Reports/StakingTransactions": 42405,
	"./Admin/Reports/StakingTransactions.vue": 42405,
	"./Admin/Reports/SystemWallets": 26450,
	"./Admin/Reports/SystemWallets.vue": 26450,
	"./Admin/Reports/Trades": 54637,
	"./Admin/Reports/Trades.vue": 54637,
	"./Admin/Reports/Wallets": 68503,
	"./Admin/Reports/Wallets.vue": 68503,
	"./Admin/Reports/Withdrawals": 71823,
	"./Admin/Reports/Withdrawals.vue": 71823,
	"./Admin/Settings/Index": 43064,
	"./Admin/Settings/Index.vue": 43064,
	"./Admin/Stakings/Form": 87458,
	"./Admin/Stakings/Form.vue": 87458,
	"./Admin/Stakings/Index": 42130,
	"./Admin/Stakings/Index.vue": 42130,
	"./Admin/Users/Form": 17825,
	"./Admin/Users/Form.vue": 17825,
	"./Admin/Users/Index": 93607,
	"./Admin/Users/Index.vue": 93607,
	"./Admin/Vouchers/Form": 12521,
	"./Admin/Vouchers/Form.vue": 12521,
	"./Admin/Vouchers/Index": 59510,
	"./Admin/Vouchers/Index.vue": 59510,
	"./Article/Article": 83876,
	"./Article/Article.vue": 83876,
	"./Article/Articles": 52011,
	"./Article/Articles.vue": 52011,
	"./Auth/ConfirmPassword": 56150,
	"./Auth/ConfirmPassword.vue": 56150,
	"./Auth/ForgotPassword": 47580,
	"./Auth/ForgotPassword.vue": 47580,
	"./Auth/Login": 90965,
	"./Auth/Login.vue": 90965,
	"./Auth/LoginAdmin": 42074,
	"./Auth/LoginAdmin.vue": 42074,
	"./Auth/Ping": 37022,
	"./Auth/Ping.vue": 37022,
	"./Auth/Register": 54288,
	"./Auth/Register.vue": 54288,
	"./Auth/ResetPassword": 14332,
	"./Auth/ResetPassword.vue": 14332,
	"./Auth/TwoFactorChallenge": 71362,
	"./Auth/TwoFactorChallenge.vue": 71362,
	"./Auth/VerifyEmail": 90006,
	"./Auth/VerifyEmail.vue": 90006,
	"./Dashboard": 95419,
	"./Dashboard.vue": 95419,
	"./Kyc/Index": 99268,
	"./Kyc/Index.vue": 99268,
	"./Launchpad/Launchpad": 51286,
	"./Launchpad/Launchpad.vue": 51286,
	"./Launchpad/Launchpads": 43356,
	"./Launchpad/Launchpads.vue": 43356,
	"./Market/Market": 7939,
	"./Market/Market.vue": 7939,
	"./Market/Markets": 19827,
	"./Market/Markets.vue": 19827,
	"./Market/Partials/MarketStats": 47072,
	"./Market/Partials/MarketStats.vue": 47072,
	"./Market/Partials/MarketTrades": 74849,
	"./Market/Partials/MarketTrades.vue": 74849,
	"./Market/Partials/MarketsWidget": 3091,
	"./Market/Partials/MarketsWidget.vue": 3091,
	"./Market/Partials/OpenOrders": 99144,
	"./Market/Partials/OpenOrders.vue": 99144,
	"./Market/Partials/OrderBook": 93947,
	"./Market/Partials/OrderBook.vue": 93947,
	"./Market/Partials/OrderForm": 47672,
	"./Market/Partials/OrderForm.vue": 47672,
	"./Market/Swap": 66985,
	"./Market/Swap.vue": 66985,
	"./Mobile/Markets": 86951,
	"./Mobile/Markets.vue": 86951,
	"./Mobile/Orders": 38618,
	"./Mobile/Orders.vue": 38618,
	"./Old_Dashboard": 90196,
	"./Old_Dashboard.vue": 90196,
	"./Order/Orders": 39076,
	"./Order/Orders.vue": 39076,
	"./Page/Page": 56392,
	"./Page/Page.vue": 56392,
	"./PeerTrade/CreatePeerTrade": 58295,
	"./PeerTrade/CreatePeerTrade.vue": 58295,
	"./PrivacyPolicy": 24647,
	"./PrivacyPolicy.vue": 24647,
	"./Profile/BankAccounts": 91454,
	"./Profile/BankAccounts.vue": 91454,
	"./Profile/DeleteUserForm": 62261,
	"./Profile/DeleteUserForm.vue": 62261,
	"./Profile/LogoutOtherBrowserSessionsForm": 60373,
	"./Profile/LogoutOtherBrowserSessionsForm.vue": 60373,
	"./Profile/ProfileInformation": 87935,
	"./Profile/ProfileInformation.vue": 87935,
	"./Profile/Show": 28542,
	"./Profile/Show.vue": 28542,
	"./Profile/TwoFactorAuthenticationForm": 85837,
	"./Profile/TwoFactorAuthenticationForm.vue": 85837,
	"./Profile/UpdatePasswordForm": 97529,
	"./Profile/UpdatePasswordForm.vue": 97529,
	"./Profile/UpdateProfileInformationForm": 13827,
	"./Profile/UpdateProfileInformationForm.vue": 13827,
	"./Profile/Vouchers": 43014,
	"./Profile/Vouchers.vue": 43014,
	"./Report/Deposits": 13380,
	"./Report/Deposits.vue": 13380,
	"./Report/FiatDeposits": 72633,
	"./Report/FiatDeposits.vue": 72633,
	"./Report/FiatWithdrawals": 2110,
	"./Report/FiatWithdrawals.vue": 2110,
	"./Report/FuturesTrades": 26074,
	"./Report/FuturesTrades.vue": 26074,
	"./Report/LaunchpadTransactions": 50163,
	"./Report/LaunchpadTransactions.vue": 50163,
	"./Report/OrderHistories": 71164,
	"./Report/OrderHistories.vue": 71164,
	"./Report/ReferralTransactions": 28096,
	"./Report/ReferralTransactions.vue": 28096,
	"./Report/Trades": 941,
	"./Report/Trades.vue": 941,
	"./Report/Withdrawals": 13273,
	"./Report/Withdrawals.vue": 13273,
	"./Staking/Staking": 71658,
	"./Staking/Staking.vue": 71658,
	"./Staking/Stakings": 37078,
	"./Staking/Stakings.vue": 37078,
	"./TermsOfService": 38886,
	"./TermsOfService.vue": 38886,
	"./Wallet/Deposit/DepositCrypto": 57377,
	"./Wallet/Deposit/DepositCrypto.vue": 57377,
	"./Wallet/Deposit/DepositFiat": 90708,
	"./Wallet/Deposit/DepositFiat.vue": 90708,
	"./Wallet/Deposit/Fiat/DepositBank": 15666,
	"./Wallet/Deposit/Fiat/DepositBank.vue": 15666,
	"./Wallet/Deposit/Fiat/DepositCc": 63280,
	"./Wallet/Deposit/Fiat/DepositCc.vue": 63280,
	"./Wallet/Deposit/Fiat/DepositFiatSuccess": 24896,
	"./Wallet/Deposit/Fiat/DepositFiatSuccess.vue": 24896,
	"./Wallet/Wallets": 74027,
	"./Wallet/Wallets.vue": 74027,
	"./Wallet/Withdraw/Coin/WithdrawCryptoSuccess": 37731,
	"./Wallet/Withdraw/Coin/WithdrawCryptoSuccess.vue": 37731,
	"./Wallet/Withdraw/Fiat/WithdrawFiatSuccess": 51703,
	"./Wallet/Withdraw/Fiat/WithdrawFiatSuccess.vue": 51703,
	"./Wallet/Withdraw/WithdrawCrypto": 65598,
	"./Wallet/Withdraw/WithdrawCrypto.vue": 65598,
	"./Wallet/Withdraw/WithdrawFiat": 78745,
	"./Wallet/Withdraw/WithdrawFiat.vue": 78745
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83218;